import AddFeatureDialog from "@components/dialogs/add_feature"
import AddNewLimitsDialog from "@components/dialogs/add_new_limits"
import AddTextToMessageToHistoryDialog from "@components/dialogs/add_text_to_message_to_history"
import CreateAiBot from "@components/dialogs/create_ai_bot"
import CreateDefaultSystemReports from "@components/dialogs/create_default_system_reports"
import MigrateAiRoles from "@components/dialogs/migrate_ai_roles"
import CreateCollageTemplateSetDialog from "@components/dialogs/create_collage_template_set"
import CustomerPaymentCardsAndEmails from "@components/dialogs/customer_payment_cards_and_emails"
import DeleteAllRedisData from "@components/dialogs/delete_all_redis_data"
import DeleteMailRateLimit from "@components/dialogs/delete_mail_rate_limit"
import DeletePersons from "@components/dialogs/delete_persons"
import DublicateFlowDialog from "@components/dialogs/dublicate_flow"
import HumanReplyLearningRunDialog from "@components/dialogs/human_reply_learning_run"
import HumanReplyLearningStatusDialog from "@components/dialogs/human_reply_learning_status"
import ProductImageIndexStatusDialog from "@components/dialogs/product_image_index_status"
import LoadDefaultTickets from "@components/dialogs/load_default_tickets"
import LoadDefaultUserRoles from "@components/dialogs/load_default_user_roles"
import MigrateConversationDetails from "@components/dialogs/migrate_conversation_details"
import MigrateTags from "@components/dialogs/migrate_tags"
import ReembedKnowledgeSourcesToContextualRagDialog from "@components/dialogs/reembed_knowledge_sources_to_contextual_rag"
import ResyncQuickAnswerRagDialog from "@components/dialogs/resync_quick_answer_rag"
import StandardizeLiveChat from "@components/dialogs/standardize_live_chat"
import AddWhatsappBusinessToMetaBusinessDialog from "@components/dialogs/whatsapp_business_to_meta_business"
import AddWhatsappWebToApiDialog from "@components/dialogs/whatsapp_web_to_api"
import { useScriptsPageContext } from "@contexts/main/scripts_page_context"
import { Box, Button } from "@mui/material"
import { useState } from "react"

export type ScriptFormData = {
  fieldName: string
  plan: string
  feature: boolean
}

export type ScriptLimitFormData = {
  fieldName: string
  usage: number
  limit: number
  plan: string
}

export type ScriptWhatsappFormData = {
  channelId: string
}

type DialogKey =
  | "addFeature"
  | "addLimit"
  | "whatsapp"
  | "metaWhatsapp"
  | "deletePersons"
  | "dublicateFlow"
  | "textToHistory"
  | "deleteRedisData"
  | "deleteMailRateLimitKeys"
  | "loadDefaultTickets"
  | "loadDefaultUserRoles"
  | "migrateTags"
  | "migrateConversationDetails"
  | "standardizeLiveChat"
  | "createAiBot"
  | "customerPaymentCardsAndEmails"
  | "createCollageTemplateSet"
  | "reembedKnowledgeSourcesToContextualRag"
  | "humanReplyLearningRun"
  | "humanReplyLearningStatus"
  | "productImageIndexStatus"
  | "resyncQuickAnswerRag"
  | "setUpdateNotification"
  | "createDefaultSystemReports"
  | "migrateAiProfileRoles"
  | "migrateAiPromptRoles"
  | null

export default function ScriptsPage() {
  const { translate } = useScriptsPageContext()
  const [openDialog, setOpenDialog] = useState<DialogKey>(null)
  const [humanReplyLearningStatusSeed, setHumanReplyLearningStatusSeed] =
    useState<{
      customerId?: string
      jobId?: string
    }>({})

  return (
    <>
      <Box
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "30rem"
        }}
      >
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("addFeature")}
          variant="contained"
        >
          {translate("products_add_new_feature")}
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("addLimit")}
          variant="contained"
        >
          {translate("customer_products_add_new_limit")}
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("whatsapp")}
          variant="contained"
        >
          WhatsApp web / Meta to Gubsup API
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("metaWhatsapp")}
          variant="contained"
        >
          WhatsApp Gubshup API / Web to Meta Business
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("deletePersons")}
          variant="contained"
        >
          Delete Persons
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("dublicateFlow")}
          variant="contained"
        >
          Dublicate Flow
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("textToHistory")}
          variant="contained"
        >
          Add text to message to history
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("deleteRedisData")}
          variant="contained"
        >
          Delete all redis data
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("deleteMailRateLimitKeys")}
          variant="contained"
        >
          {translate("delete_mail_rate_limit_keys")}
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("loadDefaultTickets")}
          variant="contained"
        >
          Load Default Tickets
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("loadDefaultUserRoles")}
          variant="contained"
        >
          Load Default User Roles
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("migrateTags")}
          variant="contained"
        >
          Migrate Tags
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("migrateConversationDetails")}
          variant="contained"
        >
          Migrate Conversation Details
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("createAiBot")}
          variant="contained"
        >
          Create Ai Bot
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("standardizeLiveChat")}
          variant="contained"
        >
          Standardize Live Chat Accounts
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("customerPaymentCardsAndEmails")}
          variant="contained"
        >
          Customer Payment Cards And Emails
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("createCollageTemplateSet")}
          variant="contained"
        >
          Create Collage Template Set
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() =>
            setOpenDialog("reembedKnowledgeSourcesToContextualRag")
          }
          variant="contained"
        >
          Re-embed Knowledge Sources to Contextual RAG
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("resyncQuickAnswerRag")}
          variant="contained"
        >
          Re-sync Quick Answer RAG
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => {
            setHumanReplyLearningStatusSeed({})
            setOpenDialog("humanReplyLearningRun")
          }}
          variant="contained"
        >
          Run Human Reply Learning
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => {
            setHumanReplyLearningStatusSeed({})
            setOpenDialog("humanReplyLearningStatus")
          }}
          variant="contained"
        >
          Human Reply Learning Status
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("productImageIndexStatus")}
          variant="contained"
        >
          {translate("image_index_admin_title")}
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("createDefaultSystemReports")}
          variant="contained"
        >
          Create Default System Reports
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("migrateAiProfileRoles")}
          variant="contained"
        >
          Migrate AI Profiles To Roles
        </Button>
        <Button
          sx={{ width: "100%", mr: "1rem" }}
          onClick={() => setOpenDialog("migrateAiPromptRoles")}
          variant="contained"
        >
          Migrate AI Prompts To Roles
        </Button>
        <AddFeatureDialog
          isOpen={openDialog === "addFeature"}
          setIsOpen={(v) => setOpenDialog(v ? "addFeature" : null)}
        />
        <AddNewLimitsDialog
          isOpen={openDialog === "addLimit"}
          setIsOpen={(v) => setOpenDialog(v ? "addLimit" : null)}
        />
        <AddWhatsappWebToApiDialog
          isOpen={openDialog === "whatsapp"}
          setIsOpen={(v) => setOpenDialog(v ? "whatsapp" : null)}
        />
        <AddWhatsappBusinessToMetaBusinessDialog
          isOpen={openDialog === "metaWhatsapp"}
          setIsOpen={(v) => setOpenDialog(v ? "metaWhatsapp" : null)}
        />
        <AddTextToMessageToHistoryDialog
          isOpen={openDialog === "textToHistory"}
          setIsOpen={(v) => setOpenDialog(v ? "textToHistory" : null)}
        />
        <DeletePersons
          isOpen={openDialog === "deletePersons"}
          setClose={() => setOpenDialog(null)}
        />
        <DublicateFlowDialog
          isOpen={openDialog === "dublicateFlow"}
          setIsOpen={(v) => setOpenDialog(v ? "dublicateFlow" : null)}
        />
        <DeleteAllRedisData
          isOpen={openDialog === "deleteRedisData"}
          setIsOpen={(v) => setOpenDialog(v ? "deleteRedisData" : null)}
        />
        <DeleteMailRateLimit
          isOpen={openDialog === "deleteMailRateLimitKeys"}
          setIsOpen={(v) => setOpenDialog(v ? "deleteMailRateLimitKeys" : null)}
        />
        <LoadDefaultTickets
          isOpen={openDialog === "loadDefaultTickets"}
          setIsOpen={(v) => setOpenDialog(v ? "loadDefaultTickets" : null)}
        />
        <LoadDefaultUserRoles
          isOpen={openDialog === "loadDefaultUserRoles"}
          setIsOpen={(v) => setOpenDialog(v ? "loadDefaultUserRoles" : null)}
        />
        <MigrateTags
          isOpen={openDialog === "migrateTags"}
          setIsOpen={(v) => setOpenDialog(v ? "migrateTags" : null)}
        />
        <MigrateConversationDetails
          isOpen={openDialog === "migrateConversationDetails"}
          setIsOpen={(v) =>
            setOpenDialog(v ? "migrateConversationDetails" : null)
          }
        />
        <StandardizeLiveChat
          isOpen={openDialog === "standardizeLiveChat"}
          setIsOpen={(v) => setOpenDialog(v ? "standardizeLiveChat" : null)}
        />
        <CreateAiBot
          isOpen={openDialog === "createAiBot"}
          setIsOpen={(v) => setOpenDialog(v ? "createAiBot" : null)}
        />
        <CustomerPaymentCardsAndEmails
          isOpen={openDialog === "customerPaymentCardsAndEmails"}
          setIsOpen={(v) =>
            setOpenDialog(v ? "customerPaymentCardsAndEmails" : null)
          }
        />
        <CreateCollageTemplateSetDialog
          isOpen={openDialog === "createCollageTemplateSet"}
          setIsOpen={(v) =>
            setOpenDialog(v ? "createCollageTemplateSet" : null)
          }
        />
        <ReembedKnowledgeSourcesToContextualRagDialog
          isOpen={openDialog === "reembedKnowledgeSourcesToContextualRag"}
          setIsOpen={(v) =>
            setOpenDialog(v ? "reembedKnowledgeSourcesToContextualRag" : null)
          }
        />
        <ResyncQuickAnswerRagDialog
          isOpen={openDialog === "resyncQuickAnswerRag"}
          setIsOpen={(v) => setOpenDialog(v ? "resyncQuickAnswerRag" : null)}
        />
        <HumanReplyLearningRunDialog
          isOpen={openDialog === "humanReplyLearningRun"}
          setIsOpen={(v) => setOpenDialog(v ? "humanReplyLearningRun" : null)}
          onStarted={({ customerId, jobId }) => {
            setHumanReplyLearningStatusSeed({
              customerId,
              jobId
            })
            setOpenDialog("humanReplyLearningStatus")
          }}
        />
        <HumanReplyLearningStatusDialog
          isOpen={openDialog === "humanReplyLearningStatus"}
          setIsOpen={(v) =>
            setOpenDialog(v ? "humanReplyLearningStatus" : null)
          }
          initialCustomerId={humanReplyLearningStatusSeed.customerId}
          initialJobId={humanReplyLearningStatusSeed.jobId}
        />
        <ProductImageIndexStatusDialog
          isOpen={openDialog === "productImageIndexStatus"}
          setIsOpen={(v) => setOpenDialog(v ? "productImageIndexStatus" : null)}
        />
        <CreateDefaultSystemReports
          isOpen={openDialog === "createDefaultSystemReports"}
          setIsOpen={(v) =>
            setOpenDialog(v ? "createDefaultSystemReports" : null)
          }
        />
        <MigrateAiRoles
          isOpen={openDialog === "migrateAiProfileRoles"}
          setIsOpen={(v) => setOpenDialog(v ? "migrateAiProfileRoles" : null)}
          target="PROFILES"
        />
        <MigrateAiRoles
          isOpen={openDialog === "migrateAiPromptRoles"}
          setIsOpen={(v) => setOpenDialog(v ? "migrateAiPromptRoles" : null)}
          target="PROMPTS"
        />
      </Box>
    </>
  )
}
